var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('q-page',{staticClass:"flex-center"},[_c('div',{staticClass:"q-pa-md "},[_c('h2',[_vm._v("Novo modelo de email")]),_c('q-select',{attrs:{"label":"Tipo do email","options":_vm.types,"map-options":"","emit-value":"","option-value":"value","option-label":"label"},model:{value:(_vm.form.type),callback:function ($$v) {_vm.$set(_vm.form, "type", $$v)},expression:"form.type"}}),_c('br'),_c('q-input',{attrs:{"label":"Nome do modelo *","rules":[_vm.required]},model:{value:(_vm.form.name),callback:function ($$v) {_vm.$set(_vm.form, "name", $$v)},expression:"form.name"}}),_c('q-input',{attrs:{"label":"Assunto *","rules":[_vm.required]},model:{value:(_vm.form.subject),callback:function ($$v) {_vm.$set(_vm.form, "subject", $$v)},expression:"form.subject"}}),(_vm.form.type == 'Text')?_c('q-input',{attrs:{"rules":[_vm.requiredText],"label":"Saudação (obrigatório para texto)"},model:{value:(_vm.form.greeting),callback:function ($$v) {_vm.$set(_vm.form, "greeting", $$v)},expression:"form.greeting"}}):_vm._e(),_c('br'),_c('br'),(_vm.form.type == 'Text')?_c('q-editor',{attrs:{"dense":"","fonts":{
      arial: 'Arial',
      arial_black: 'Arial Black',
      comic_sans: 'Comic Sans MS',
      courier_new: 'Courier New',
      impact: 'Impact',
      lucida_grande: 'Lucida Grande',
      times_new_roman: 'Times New Roman',
      verdana: 'Verdana'
    },"toolbar":[
      [

        {
          label: _vm.$q.lang.editor.align,
          icon: _vm.$q.iconSet.editor.align,
          fixedLabel: true,
          options: ['left', 'center', 'right', 'justify']
        }
      ],
      ['bold', 'italic', 'strike', 'underline', 'subscript', 'superscript'],
      ['token', 'hr', 'link', 'custom_btn'],
      ['print', 'fullscreen'],
      [
        {
          label: _vm.$q.lang.editor.formatting,
          icon: _vm.$q.iconSet.editor.formatting,
          list: 'no-icons',
          options: [
            'p',
            'h1',
            'h2',
            'h3',
            'h4',
            'h5',
            'h6',
            'code'
          ]
        },
        {
          label: _vm.$q.lang.editor.fontSize,
          icon: _vm.$q.iconSet.editor.fontSize,
          fixedLabel: true,
          fixedIcon: true,
          list: 'no-icons',
          options: [
            'size-1',
            'size-2',
            'size-3',
            'size-4',
            'size-5',
            'size-6',
            'size-7'
          ]
        },
        {
          label: _vm.$q.lang.editor.defaultFont,
          icon: _vm.$q.iconSet.editor.font,
          fixedIcon: true,
          list: 'no-icons',
          options: [
            'default_font',
            'arial',
            'arial_black',
            'comic_sans',
            'courier_new',
            'impact',
            'lucida_grande',
            'times_new_roman',
            'verdana'
          ]
        },
        'removeFormat'
      ],
      ['quote', 'unordered', 'ordered'],

      ['undo', 'redo']
    ]},model:{value:(_vm.form.body),callback:function ($$v) {_vm.$set(_vm.form, "body", $$v)},expression:"form.body"}}):_vm._e(),_c('q-uploader',{attrs:{"url":_vm.url,"label":"Imagem","factory":_vm.uploadFactory,"color":"purple-10","send-raw":"","with-credentials":"","max-file-size":_vm.maxSize,"auto-upload":true},on:{"uploaded":_vm.finished,"finish":_vm.finished,"removed":function($event){_vm.form.file = ''}}}),_c('br'),_c('q-btn',{attrs:{"label":"Preview","type":"a","target":"_blank","href":_vm.preview,"color":"primary"}}),_c('br'),_c('br'),_c('q-btn',{attrs:{"label":"Salvar","color":"primary"},on:{"click":_vm.salvar}})],1),_c('q-inner-loading',{attrs:{"showing":_vm.loading}},[_c('q-spinner-dots',{attrs:{"size":"50px","color":"primary"}})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }